(function ($) {
  /**Menu**/
  function customSubMenu(){
    $( ".nav-dropdown.nav-dropdown--first" ).each(function( index ) {
      if(!$(this).find(".nav-dropdown--second").length){
          $(this).parent().addClass("not-dropdown-second");
      }
    });
  }

  customSubMenu();

  /**Search page**/
  $('.search__form .input-group__submit').on('click', function(){
    var input_search = $(".search__form .form__input").val().replace("/", " ");
    $(".search__form .form__input").val(input_search);
  });

  /**Tooltip**/
  $(".price-tooltip, .point-tooltip").mouseover(function(){
    if($(window).innerWidth() > 800){
      var scrollTop     = $(window).scrollTop(),
          elementOffset = $(this).offset().top,
          distance      = elementOffset - scrollTop,
          tooltip = $(this).next(),
          heightTooltip = tooltip.height(),
          heightWindow = $(window).innerHeight();

      tooltip.removeClass("move-to-top");
      tooltip.removeClass("move-to-bottom");

      if(distance + heightTooltip >= heightWindow ){
        // var newPosition = 0;
        //update position tooltip
        tooltip.addClass("move-to-top");
      }
      else if(distance <= heightTooltip){
        tooltip.addClass("move-to-bottom");
      }
      else{
        tooltip.removeClass("new-position");
      }
    }
  });


  /**FOOTER**/
  $('.menu_links > h2').on('click', function(){
    var parent = $(this).parent(),
        windowWidth = window.innerWidth;

    if(windowWidth <= 800){
        parent.toggleClass("open");
    }
  });

  var getUrlParameter = function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;

      for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');

          if (sParameterName[0] === sParam) {
              return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
          }
      }
      return 1;
  };

  $(document).ready(function() {
    //remove provine
    if($(".address_form").length){
      $(".address_form").find('option[value="Putrajaya"]').remove();
    }
    
    if($(".review-tab-title").length){
      $(".review-tab-title").hide();
      $(".review-tab-m").parents(".tabs__nav-item-m").hide();
    }
    
    $(".review-tab-title").on("click", function(){
        // showReview(false);
        // moveReviewToTabs();
    });

    checkRating();
    
    if($("body").hasClass("template-product")){
      moveReviewToTabs();
    }

    initWishlist();

  });

  /**Disable Scroll on mobile**/

  function disableScroll(){
      $('.header__nav-toggle').on('touchmove', function (evt) {
          evt.preventDefault();
      });
  }
  
  function enableScroll(){
      $('.header__nav-toggle').off('touchmove', function (evt) {
          evt.preventDefault();
      });
  }

  $('.header__nav-toggle').on('click', function (evt) {
      checkDevice();
  });

  function checkDevice(){
      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;
      if(windowWidth <= 1024 && $('.sidebar-nav').hasClass('sidebar-nav--open')){
          disableScroll();
      }
      else {
          enableScroll();
      }
  }

  function closeMinicart() {
      if(headerSearch.hasClass('header-search--open')) {
          headerSearch.removeClass('header-search--open');
      }
      if(miniCart.hasClass('mini-cart--open')) {
          miniCart.removeClass('mini-cart--open');
      }
      if(userLink.hasClass('open')) {
          userLink.removeClass('open');
          navUser.hide();
      }

      $('.page__overlay').removeClass('page__overlay--open');

      $("body").removeClass('no-scroll');

  }

  $('.page__overlay').bind('touchstart', function(e){
      closeMinicart();
  });

  $(document).on("click", '.close-minicart', function(event) {
      closeMinicart();
  });

  $(window).resize(function() {
    checkDevice();
    moveReviewToTabs(); 
  });

  /**Nav User Drop Down in Header**/
  var userLink = $('.user__link');
  var navUser = userLink.find('.nav-dropdown');
  var miniCart = $(".mini-cart");
  var headerSearch = $(".header-search");


  $(document).click(function (e) {

      if (!e) e = window.event;

      if($(e.target).hasClass("nav-dropdown__link")){
          //sub menu
          window.location.href = $(e.target).attr("href");
      }
      else if( $(e.target).hasClass("user__link") ||  $(e.target).parents(".user__link").length
          || $(e.srcElement).parents(".user__link").length
          || $(e.srcElement).hasClass("user__link")  ){

          if(headerSearch.hasClass('header-search--open')) {
              headerSearch.removeClass('header-search--open');
          }

          if(miniCart.hasClass('mini-cart--open')) {
              miniCart.removeClass('mini-cart--open');
          }

          if(userLink.hasClass('open')) {
              userLink.removeClass('open');
              $("body").removeClass('no-scroll');
              navUser.hide();
              $('.page__overlay').removeClass('page__overlay--open');
          }
          else {
              userLink.addClass('open');
              $("body").addClass('no-scroll');
              navUser.show();
              $('.page__overlay').addClass('page__overlay--open');
          }
      }
      else if( $(e.target).hasClass("search-form") ||  $(e.target).parents(".search-form").length  ){

          if(miniCart.hasClass('mini-cart--open')) {
              miniCart.removeClass('mini-cart--open');
          }

          if(userLink.hasClass('open')) {
              userLink.removeClass('open');
              navUser.hide();

          }
      }
      else {
          if( $(e.target).hasClass("page__overlay")){
              if(headerSearch.hasClass('header-search--open')) {
                  headerSearch.removeClass('header-search--open');
              }
              if(miniCart.hasClass('mini-cart--open')) {
                  miniCart.removeClass('mini-cart--open');
              }
              if(userLink.hasClass('open')) {
                  userLink.removeClass('open');
                  navUser.hide();
              }
              $('.page__overlay').removeClass('page__overlay--open');
              $("body").removeClass('no-scroll');
          }

          else if( $(e.target).hasClass("mini-cart-menu") || $(e.target).parents(".mini-cart-menu").length){
              if(headerSearch.hasClass('header-search--open')) {
                  headerSearch.removeClass('header-search--open');
              }
              if(userLink.hasClass('open')) {
                  userLink.removeClass('open');
                  navUser.hide();
              }
          }
      }

  });

  function phone_validate(phno){
    var regexPattern=new RegExp(/^[0-9]+$/);    // regular expression pattern
    return regexPattern.test(phno);
  }

  function getValidatePartnerQuota(cartItems, callback, token) {
    const customerInfoElm = $('#customer-infor');
  
    const customerInfo = {
      customerId: customerInfoElm.data('customer-id'),
      partnerCode: customerInfoElm.data('partner-code'),
      customerEmail: customerInfoElm.data('customer-email'),
    };
  
    if(!customerInfo.customerId) {
      callback();
      return;
    };
  
    const dataItems = cartItems.map(item => ({
      variantid: item.variant_id,
      productid: item.product_id,
      quantity: item.quantity
    }));
  
    const storeId = window.partner.storeId.toString();
    const dataString = JSON.stringify({
      storeid: storeId,
      customeremail: customerInfo.customerEmail,
      partnerCode: customerInfo.partnerCode,
      cartitemids: dataItems
    });
  
    $.ajax({
      method: 'POST',
      async: false,
      url: `${window.partner.omsValidateOrderQuotation}`,
      headers: {
        'Authorization': `Bearer ${token}`,
        'issuer': storeId,
        'Accept-Language': 'en-US'
      },
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({
        'jsonstr': dataString
      })
  
    }).done(result => {
      if (result) {
        const valueReult = JSON.parse(result.value);
        callback(valueReult[0]);
      }
    })
    .fail(err => {
      console.log('err: ', err);
    });
  };

  function ValidatePartnerQuota(hrefUrl, id, increase_quantity, currentQty, self) {
    $.ajax({
      method: 'GET',
      url: '/cart.js',
      dataType: 'json'
    }).then(function(cart) {
      const newCartItems = cart.items?.filter(ele => ele.properties['_new_line_price'] && ele.properties['_new_line_price'] != 'NaN');

      const increaseItem = newCartItems.find((item) => {
        return item.id == id
      });

      if (increaseItem) {
        increaseItem.quantity = parseInt(increase_quantity);
      }

      window.getOMSAccessToken().then((token) => {
        getValidatePartnerQuota(newCartItems, function(result) {
          if(result && result.validTotalQuota.toLowerCase() === "false") {
            if(currentQty) {
              self.val(currentQty);
            }

            self.parent().find('.error_Msg').css("display", "block");
            self.addClass("has-error");
  
            alert('The total/yearly quota has exceeded.');
            
            return;
          }
  
          if (result) {
            let strError = '';
            const arrayInValidVariantIds = JSON.parse(result.inValidVariantIds.replace(',]', ']'));
  
            if (arrayInValidVariantIds && arrayInValidVariantIds.length > 0) {
              arrayInValidVariantIds.forEach(element => {
                const dataItem = newCartItems.find(item => item.variant_id == element);
  
                if (dataItem) {
                  strError += 'The product "' + dataItem.title + '" has exceeded category quota.\n';
                }
              });
  
              if (strError.length > 0) {
                if(currentQty) {
                  self.val(currentQty);
                }
  
                self.parent().find('.error_Msg').css("display", "block");
                self.addClass("has-error");

                alert(strError);
                return;
              }
            }
            
            window.location.href = hrefUrl;
            
          }
        }, token);        
      }).catch(err => console.log('error when call get OMS access token', err));

    });
  }

  //update quantity in cart page
  $('.form-cart').keypress( function(e){
    const key = e.charCode || e.keyCode || 0;
    
    if (key == 13) {
      e.preventDefault();
    }
  });

  $(".quantity-selector .decrease-quantity").click( function(event){
    event.preventDefault();

    $(this).parent().find('.error_Msg').hide();

    var link = $(this).attr("data-link"),
        newPrice = $(this).closest('.cart-item').data('new-price'),
        quantity = $(this).data('quantity');

    var current_quantity = $(this).parent().find('input[name="update_quantity"]').val();

    quantity = parseInt(quantity);

    if (current_quantity != "" && phone_validate(current_quantity)) {
      if (current_quantity > 0) {
        var decrease_quantity = parseInt(current_quantity) - 1;

        window.location.href = link + "&quantity=" + decrease_quantity + "&properties[_new_line_price]=" + decrease_quantity * newPrice;
      } 
      else {
        $(this).parent().find('.error_Msg').css("display", "block");
        $(this).addClass("has-error");
      }
    } 
    else {
      $(this).parent().find('.error_Msg').css("display", "block");
      $(this).addClass("has-error");
    }
  });

  $(".quantity-selector .increase-quantity").click( function(event){
    event.preventDefault();

    $(this).parent().find('.error_Msg').hide();

    var inventory_quantity = $(this).data('inventory-quantity'),
        link = $(this).attr("data-link"),
        id = $(this).attr("data-id"),
        newPrice = $(this).closest('.cart-item').data('new-price'),
        quantity = $(this).data('quantity');

    var current_quantity = $(this).parent().find('input[name="update_quantity"]').val();

    quantity = parseInt(quantity);
    inventory_quantity = parseInt(inventory_quantity);

    if (current_quantity != "" && phone_validate(current_quantity)) {
      if (current_quantity >= inventory_quantity) {
        $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').text(window.languages.sold_out_message);
        $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').css("display", "block"); // shows validation msg if validation is false
        $(this).addClass("has-error");
      } 
      else if (current_quantity > 0) {
        var increase_quantity = parseInt(current_quantity) + 1;

        const url = link + "&quantity=" + increase_quantity + "&properties[_new_line_price]=" + increase_quantity * newPrice;

        ValidatePartnerQuota(url, id, increase_quantity, undefined , $(this));
      } 
      else {
        $(this).parent().find('.error_Msg').css("display", "block");
        $(this).addClass("has-error");
      }
    } 
    else {
      $(this).parent().find('.error_Msg').css("display", "block");
      $(this).addClass("has-error");
    }
  });

  $(".quantity-selector__current-quantity").on('change', function(event){
    event.preventDefault();

    var link = $(this).attr("data-link"),
        id = $(this).data('id'),
        newPrice = $(this).closest('.cart-item').data('new-price'),
        quantity = $(this).val(),
        inventoryQty = parseInt($(this).attr("data-inventory-quantity"));

    var currentQty = $(this).data('value');

    if (phone_validate(quantity) && quantity > 0) {
      if (quantity > inventoryQty) {
        $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').text(window.languages.sold_out_message);
        $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').css("display", "block"); // shows validation msg if validation is false
        $(this).addClass("has-error");
      } else {
      $(this).parent().find('.error_Msg').hide(); // hides error msg if validation is true
      $(this).removeClass("has-error");

      if (phone_validate(quantity)) {
        const url = link + "&quantity=" + quantity + "&properties[_new_line_price]=" + quantity * newPrice;

        ValidatePartnerQuota(url, id, quantity, currentQty, $(this));
      }
    } 
    } 
    else {
      $(this).parent().find('.error_Msg').css("display", "block"); // shows validation msg if validation is false
      $(this).addClass("has-error");
    }
  });

  $(".quantity-selector__current-quantity").on('keyup', function(event){
    event.preventDefault();

    var link = $(this).attr("data-link"),
        id = $(this).data('id'),
        newPrice = $(this).closest('.cart-item').data('new-price'),
        quantity = $(this).val();

    var currentQty = $(this).data('value');

    if (currentQty !== parseInt(quantity) && (event.key === 'Enter' || event.keyCode === 13)) {
      if (phone_validate(quantity) && quantity > 0) {
        $(this).parent().find('.error_Msg').hide(); // hides error msg if validation is true
        $(this).removeClass("has-error");
  
        if (phone_validate(quantity)) {
          const url = link + "&quantity=" + quantity + "&properties[_new_line_price]=" + quantity * newPrice;
  
          ValidatePartnerQuota(url, id, quantity, currentQty, $(this));
          // window.location.href = link + "&quantity=" + quantity + "&properties[_new_line_price]=" + quantity * newPrice;
        }
      } 
      else {
        $(this).parent().find('.error_Msg').css("display", "block"); // shows validation msg if validation is false
        $(this).addClass("has-error");
      }     
    }
  });

  $(".cart__checkout-button").on("click", function(){
    if($(".quantity-selector__current-quantity").hasClass("has-error")){
      return false;
    }
  });

  $(".main-menu__links > li").click(function(){
    setTimeout(function(){
        checkDevice();
    }, 500);
  });

  function initWishlist() {
    const customerInfoElm = $('#customer-infor');

    const customerInfo = {
      customerId: customerInfoElm.data('customer-id'),
      partnerCode: customerInfoElm.data('partner-code'),
      customerEmail: customerInfoElm.data('customer-email'),
    };

    if(customerInfo.customerId === '') {
      loginWishlist();
    }
    else {
      checkWishlistStatus(customerInfo);
      addWishlist(customerInfo);
      removeWishlist(customerInfo);
      getWishlist(customerInfo);
      initWishlistCollectionEvt();
    }
  }

  function loginWishlist(){
    $('.wishlist-modal').click(function(e){
      var container = $(".wishlist-modal .content");

      if (!container.is(e.target) && container.has(e.target).length === 0){
        $('.wishlist-modal').removeClass('wishlist-popup-wrapper');
      }
    });

    $(".wishlist_login").on("click", function(e){
      e.preventDefault();

      $(".wishlist-modal").toggleClass('wishlist-popup-wrapper');

      $(".wishlist-modal .close-popup").on("click", function(){
        $(".wishlist-modal").removeClass('wishlist-popup-wrapper');
      });
    });
  }

  function updateWishlistStatus(isActive, elms) {
    if(isActive) {
      elms.addClass('btn-active');
      elms.find('.tooltip').text(window.languages.removeWishlistText);
    }
    else {
      elms.removeClass('btn-active');
      elms.find('.tooltip').text(window.languages.addWishlistText);
    }
  }

  const apiRequest = new ApiFetch();

  function checkWishlistStatus(customerInfo) {
    const wishlistElm = $('.wishlist_collections');
    apiRequest.fetcher('wishlist')
      .then(function(res) {
        if(!res?.data.length) return;

        // Update wishlist detail page
        const productDetailWishlist = $('.product__details .wishlist_collections');

        if(productDetailWishlist.length) {
          productDetailWishlist.each((_, w) => {
            const productHandle = $(w).data('product-handle');

            const handles = res.data.filter((item) => {
              return item.handle == productHandle;
            });

            const listVariantId = handles.map((v) => {
              return v.variant_id;
            })

            $(w).siblings('.input_variants').attr('data_variants', listVariantId);
          })
        }

        wishlistElm.each((_, w) => {
          const variantId = $(w).data('variant-id');

          const isActive = res.data.some((item) => {
            return item.variant_id == variantId;
          });

          updateWishlistStatus(isActive, $(w));
        });

        $('.wishlist__count').text(res?.data.length);
      })
      .fail((err) => {
        console.log('error when call api get WishlistMetafields_Partner', err);
      });
  }

  function addWishlist(customerInfo){
    const addWishlistSlt = '.wishlist_collections';

    $(document).off('click.addWishlist', addWishlistSlt).on('click.addWishlist', addWishlistSlt, function(e) {
      e.preventDefault();

      const self = $(this);
      self.addClass('disabled');
      self.find('.tooltip').text(window.languages.added);

      if(!self.hasClass('btn-active')) {
        const productId = self.data('product-id'),
              ProductHandle = self.data('product-handle'),
              variantId = self.data('variant-id');

        apiRequest.post('wishlist', {
          "product_id": productId,
          "variant_id": variantId,
          "handle": ProductHandle
        }).then(function(res){
          if(res.status) {
            self.addClass('btn-active');
  
            let wishlistCount = $('.header__secondary-nav .wishlist__count').text();
            wishlistCount = parseInt(wishlistCount) + 1;
  
            $.cookie("els", wishlistCount);
            $('.wishlist__count').text(wishlistCount);
  
            updateWishlistStatus(true, $(`${addWishlistSlt}[data-variant-id=${variantId}]`));
          }

        })
        .fail((err) => {
          console.log('error when call api add WishlistMetafields_Partner', err);
        })
        .always(() => {
          self.removeClass('disabled');
        });        
      }
    })
     
  };

  function removeWishlist(customerInfo){
    const removeWishlistSlt = '.wishlist_collections.btn-active';

    $(document).off('click.removeWishlist', removeWishlistSlt).on('click.removeWishlist', removeWishlistSlt, function(e) {
      e.preventDefault();

      const self = $(this);
      self.addClass('disabled');
      self.find('.tooltip').text(window.languages.removed);

      const productHandle = self.data('product-handle'),
            variantId = self.data('variant-id');

      apiRequest.delete('wishlist', {
        'handle': productHandle,
        'variant_id': variantId
      }).then(function(res){
        if(res.status) {
          self.removeClass('btn-active');
  
          let wishlistCount = $('.header__secondary-nav .wishlist__count').text();
          wishlistCount = parseInt(wishlistCount) - 1;
  
          $.cookie("els", wishlistCount);
          $('.wishlist__count').text(wishlistCount);
  
          updateWishlistStatus(false, $(`.wishlist_collections[data-variant-id=${variantId}]`));
        }
      })
      .fail((err) => {
        console.log('error when call api remove WishlistMetafields_Partner', err);
      })
      .always(() => {
        self.removeClass('disabled');
      });

      if(self.closest('.wishlist-content').length) {
        self.closest('.grid__cell').remove();
      }
      
    });
  }

  function getPriceForWishlist(customerInfo, listProductId, handleRenderTpl, token) {
    const storeId = window.partner.storeId.toString();

    $.ajax({
      method: 'POST',
      url: `${window.partner.omsGetPriceByListProductIds}`,
      headers: {
        'Authorization': `Bearer ${token}`,
        'issuer': storeId,
        'Accept-Language': 'en-US'
      },
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({
        'storeid': storeId,
        'listproductid': JSON.stringify(listProductId),
        'partnercode': customerInfo.partnerCode,
        'customeremail': customerInfo.customerEmail.toLowerCase()
      })

    }).done(function(res){
      const resultValue = JSON.parse(res?.value);
      // Update price data result
      handleRenderTpl(resultValue);

    })
    .fail(function(err) {
      handleRenderTpl();
      console.log('error when call api get price for wishlist page');
    });
  }

  function updateWishlistItemPrice(price, comparePrice, partnerPrice, wishlistItemElm) {
    const newPrice = comparePrice ? Math.min(price, comparePrice, partnerPrice) : Math.min(price, partnerPrice);
    const oldPrice = comparePrice ? Math.max(price, comparePrice, partnerPrice) : Math.max(price, partnerPrice);
    const discountPercent = (oldPrice - newPrice) / oldPrice * 100;

    if(partnerPrice) {
      wishlistItemElm.find('.product-content-bottom').data('new-price', newPrice);
    }

    if((comparePrice && (price === newPrice) && (comparePrice === oldPrice)) || !comparePrice && (price === newPrice)) return;

    // update price ==> format money
    if (comparePrice && oldPrice > newPrice) {
      wishlistItemElm.find(".product-item__image-container .discount").show();
      wishlistItemElm.find(".product-item__image-container .discount .price-save").html(discountPercent.toFixed(0)+"%");

      wishlistItemElm.find('.product-item__price--new').html(Shopify.formatMoney(newPrice, window.theme.moneyFormat));
      wishlistItemElm.find('.product-item__price--old').html(Shopify.formatMoney(oldPrice, window.theme.moneyFormat));
    } 
    else {
      wishlistItemElm.find(".product-item__image-container .discount").hide();
      wishlistItemElm.find('.product-item__price').html(Shopify.formatMoney(newPrice, window.theme.moneyFormat));
    };
  }

  function getWishlist(customerInfo){
    const wishlistContent = $('.wishlist-page .wishlist-content');

    if(!wishlistContent.length) return;

    apiRequest.fetcher('wishlist').then(function(res) {
        if(!res?.data.length) return;

        const data = res.data;

        const handleArr = data.map((item) => {
          return item.handle;
        });

        const productIds = data.map((item) => {
          return parseInt(item.product_id);
        })

        // Call api getPrice
        window.getOMSAccessToken().then((token) => {
          getPriceForWishlist(customerInfo, [...new Set(productIds)], function(priceData) {
            [...new Set(handleArr)].forEach((handle) => {           
              $.get('/products/'+ handle +'?view=wishlist', function(tpl) {
                const wishlistItem = $(tpl);
  
                wishlistContent.append(wishlistItem);
  
                const wishlistItems = wishlistContent.find('.grid__cell');
  
                wishlistItems.each((_, w) => {
                  const variantId = $(w).data('variant');
  
                  const hasWishlist = data.find((i) => {
                    return i.variant_id == variantId;
                  });
  
                  if(!hasWishlist) {
                    $(w).remove();
                  }
                  else {      
                    $(w).show();
  
                    if(priceData) {
                      // Update Price for wishlist item
                      const productItemId = $(w).find('.product-item').data('product-id').toString();
                      const productItemData = priceData.find(item => item.productid === productItemId);
    
                      if (!productItemData) return;
    
                      const variantId = $(w).find('.product-content-bottom').data('variant-id').toString();
                      const variantData = productItemData.variant.find(v => v.id === variantId);
    
                      if (!variantData) return;
    
                      const partnerOrginalPrice = variantData.price;
    
                      if(!partnerOrginalPrice) return;
    
                      const price = $(w).find('.product-content-bottom').data('price');
                      const comparePrice = $(w).find('.product-content-bottom').data('compare-price');
    
                      updateWishlistItemPrice(price, comparePrice, partnerOrginalPrice * 100, $(w));
                    }
                  }
  
                })
              })
            })
          }, token);
        }).catch(err => console.log('error when call get OMS access token', err));

      })
      .fail((err) => {
        console.log('error when call api get WishlistMetafields_Partner');
      });     
  }

  function initWishlistCollectionEvt() {
    if ($('.product__details').length > 0) {
      $(".product__details .wishlist_collections").click(function(){
        var s = $(this).data('variant-id');
        var d = $(".product__details .input_variants").attr("data_variants");
        var wishlistarrays = d.split(",");

        if ($.inArray($(this).attr("data-variant-id"), wishlistarrays) !== -1) {
          d = d.replace(s+",", "").replace(","+s, "").replace(s, "");
          $(".product__details .input_variants").attr("data_variants", d);
        }
        else {
          if(d != ""){
            $(".product__details .input_variants").attr("data_variants", d + "," + s);
          }
          else {
            $(".product__details .input_variants").attr("data_variants", s);
          }
        }
      });

      // var selected = $("#sony-new-variant" ).val();
      $(document).on('variant_changed.product', function(evt, variant) {
        const variantId = variant.id;
        
        $(".product__details .wishlist_collections").attr('data-variant-id', variantId);
      });

    }
  }

  function checkoutlink(){
    $(document).on('click', '.mini-cart__buttons .checkout_link, .checkout_link', function(e){
      $.cookie('check_out', "checkout",{expires:1, path:'/'});
    });

    if($.cookie('check_out') != undefined && $('.check__out').length){
      $('body.template-customers-account').hide();
      window.location.href= "/cart";
      $.removeCookie('check_out', { path: '/' });
      // $.cookie('check_out', "checkout",{expires:-1, path:'/'});
    } 
    else{
      $('body.template-customers-account').show();
      if ($('.check__out').length){
        // $('head title').text($("#sony-title-page").text());
      }
    }
  }

  if ($("body").hasClass("trademark--v3")) {
      checkoutlink();

      //custom product detail
      $( ".product-features .block-3column" ).each(function() {
          var block_3column_wrapper = $(this).html();
          $(this).html("<div>" + block_3column_wrapper + "</div>");
      });

  }

  if ($("body").hasClass("template-customers-order")) {
      /**order detail**/
      var shipping_label = $(".order__items .shipping-method").attr("data-label");

      if(shipping_label != "" && shipping_label.search ("Standard shipping") != -1){
          var shipping_label_new = shipping_label.replace("Standard shipping", window.languages.standard_shipping);
          $(".order__items .shipping-method").attr("data-label",shipping_label_new);
      }
  }

  /**Edit profile**/
  function checkUserLogin(){
      var check = false;
      var user_name = "";
      if($(".user-dropdown__item").find(".user-logined")){
          user_name = $(".user-dropdown__item .user-logined").attr("title");

          if(user_name != undefined && user_name != "") {
              check = true;
          }
      }

      if(check== false){
          window.location.href = $(".header__logo-link").attr("href");
      }
  }

  /**Validate form edit**/
  if ($("body").hasClass("trademark--v3")) {
    
    $(".find_store__form [type='submit']").click(function () {
      $('.find_store__form').validate({
        rules: {
          '#find-store-postcode': {
              required: true
          }
        },
        submitHandler: function(form) {
          var postcode = $('#find-store-postcode').val();
          var url = $(".find_store__form").attr("action");
          url = url + "/?query=" + postcode;
          window.open(url, '_blank');
          return false;
        }
      });

    });

    // $("#money_vat").text(Shopify.formatMoney($("#money_vat").text(), window.theme.order_money));
    $("#excluded_tax").text(Shopify.formatMoney($("#excluded_tax").text(), window.theme.order_money));
  }


  /***Delete Address***/
  $(".delete-address").click(function(){
      if (confirm(window.languages.delete_confirm)) {
          // your deletion code
          var address_id = $(this).attr("data-address-id");

          Shopify.postLink('/account/addresses/'+ address_id, {'parameters': {'_method': 'delete'}});
      }
      else{
          event.preventDefault();
      }

      return false;
  });
  
  function showReview(isActive){
    var id = setInterval(check, 1000);
    var i = 0;
    var k = 1;
    
    function check() {
//       console.log(i);
      if(isActive) {
      	i = 9;
      }
      if(k == 5) {
        isActive = false;
      }
      
      if( i >= 10) {
        clearInterval(id);
      }
      else {
        
        
        if($(window).innerWidth() > 800){
          if (!$('.gwt__tab-m--active .product-review-m').is(':empty')){
            //do something
//             var html = $(".gwt__tab-m--active .product-review-m").html();
//             $(".gwt__tab--active .product-review").html(html);
            moveReviewToTabs();
            i = 10;
            k++;
//             hideReviewPdp();
          }
        }
        else {
          if (!$('.gwt__tab--active .product-review').is(':empty')){
//             var html = $(".gwt__tab--active .product-review").html();
//             $(".gwt__tab-m--active .product-review-m").html(html);
            moveReviewToTabs();
			i = 10;
            k++;
//            hideReviewPdp();
          }
        }
        i++;
      }
    }
  }
  
  /**Show review tab after clicking star**/
  
  
  window.bvCallback = function(BV) {

   BV.reviews.on('show', function() {
     if($(window).innerWidth() > 800){
       $('.gwt__tab--active .tabs__nav-item.review-tab-title').click();
       
       setTimeout(function(){ 
         $('html, body').animate({
           scrollTop: $(".gwt__tab--active.product__tabs").offset().top - 100
         }, 0);

       }, 100);
       
     }
     else {
       if(!$(".gwt__tab-m--active .tabs__nav-item-m > .review-tab-title").hasClass("active")){
         $('.gwt__tab-m--active .tabs-title.review-tab-title').click();
       }
       
       setTimeout(function(){ 
         $('html, body').animate({
           scrollTop: $(".gwt__tab-m--active .tabs-title.review-tab-title").offset().top - 100
         }, 0);

       }, 100);

     }
     

       return false;

   });

};
  
  
  /**Hide no review***/
  function hideNoRating(){
    $(".product-item").each(function(){
      
      var inline_rating = $(this).find('[data-bv-show="inline_rating"]');
      var bv_text = $(this).find('.bv_text').text();
      
      
      if(bv_text != '' && bv_text != '(0)'){
//         inline_rating.hide();
        $(this).find(".bv-ratings-block").addClass("show");
      }

    });
    
    
  }
  
  function hideReviewPdp(){
    if($(".bv_numReviews_text").length) {
      if($(".bv_numReviews_text").text() == '(0)'){
        //         $('[data-bv-show="rating_summary"]').hide();
        $(".review-tab-title").hide();
        $(".gwt__tab-m--active .review-tab-m").parents(".tabs__nav-item-m").hide();
      }
      else {
        $(".product__meta .bv-ratings-block").addClass("show");
        $(".review-tab-title").show();
        $(".gwt__tab-m--active .review-tab-m").parents(".tabs__nav-item-m").show();

      }

    }
  }
  
  function checkRating() {
    var id = setInterval(check, 1000);
    var i = 0;
    
    function check() {
//       console.log("star: "+i);
      if( i >= 15 ) {
        clearInterval(id);
      }
      else {
        hideNoRating();
        hideReviewPdp();
        i++;
      }
    }
  }
  
  var reviewHtml = "";
  function moveReviewToTabs(){
    
    if($(".product-review-container").length && reviewHtml == ""){
      reviewHtml = $(".product-review-container").html();
      $(".product-review-container").remove();
//       console.log(1);
    }
    else if($(window).innerWidth() > 800 && reviewHtml == "") {
//       console.log(2);
      reviewHtml = $(".tabs__content-item.review-tab .product-review #BVRRSearchContainer").parents(".product-review").html();
    }
    else if($(window).innerWidth() <= 800 && reviewHtml == "") {
//       console.log(3);
      reviewHtml = $(".tabs__content-item-m .review-tab-m .product-review-m #BVRRSearchContainer").parents(".product-review-m").html();
    }
//     console.log(reviewHtml);
    
    if($(window).innerWidth() > 800){
      $(".product-review-m").html("");
      
      $(".product__tabs").each(function(){
        if($(this).hasClass("gwt__tab--active")){
          //move review
          $(this).find(".tabs__content-item.review-tab .product-review").html(reviewHtml);
        }
        else {
          $(this).find(".tabs__content-item.review-tab .product-review").html("");
        }
      });
    }
    else {
      $(".product-review").html("");
      $(".product__tabs-m").each(function(){
        
        if($(this).hasClass("gwt__tab-m--active")){
          //move review
          $(this).find(".tabs__content-item-m .review-tab-m .product-review-m").html(reviewHtml);
        }
        else {
          $(this).find(".tabs__content-item-m .review-tab-m .product-review-m").html("");
        }
      });   

    }                        
                          
  }
  
  var variantSelector = $(".product__form .single-option-selector");
  
  variantSelector.on("change", function() {
    $(".tabs__nav-item").removeClass("tabs__nav-item--active");
    $(".tabs__content-item").removeClass("tabs__content-item--active");
    $(".tabs-title.review-tab-title").removeClass("active");
    $(".tabs__nav-item-m .tabs-title + ul").hide();
    
    setTimeout(function(){
      $(".product__tabs.gwt__tab--active").find(".tabs__nav-item:first-child").addClass("tabs__nav-item--active");
      $(".product__tabs.gwt__tab--active").find(".tabs__content-item:first-child").addClass("tabs__content-item--active");
      $(".product__tabs-m.gwt__tab-m--active").find(".tabs__nav-item-m:first-child .tabs-title").addClass("active");
      $(".product__tabs-m.gwt__tab-m--active").find(".tabs__nav-item-m:first-child .tabs-title + ul").show();
      moveReviewToTabs();
    }, 2000);
  });

}(jQuery));


